import type { LanguageDefinition } from 'types/documentServices';
import { translate } from '#packages/i18n';

export const shouldLanguageBeInvisible = (
  isInPreviewMode: boolean,
  language?: LanguageDefinition,
) => {
  return isInPreviewMode && language?.status === 'Inactive';
};

export const extractTwoLettersLanguageCode = (languageCode: string) => {
  return languageCode.split('-')[0];
};

export const getLocaleFullName = (locale: LanguageDefinition): string =>
  getLanguageFullName(
    extractTwoLettersLanguageCode(locale.languageCode),
    locale.regionCode,
  );

export const getLanguageFullName = (
  twoLettersLanguageCode: string,
  regionCode?: string,
) => {
  return regionCode
    ? `${translate(
        `locale-dataset.languages.${twoLettersLanguageCode}`,
      )} (${regionCode.toUpperCase()})`
    : translate(`locale-dataset.languages.${twoLettersLanguageCode}`);
};
